var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepIncompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16.5,
    r: 16,
    stroke: "#1F2A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIncompleteIcon);
export default __webpack_public_path__ + "static/media/step-incomplete-icon.e334205057a07c1e32676bb01c919605.svg";
export { ForwardRef as ReactComponent };